import script from "./SacarTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SacarTab.vue?vue&type=script&setup=true&lang=js"

import "./SacarTab.vue?vue&type=style&index=0&id=b8d7e3b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d7e3b2"]])

export default __exports__